import MultiSelect from "@khanacademy/react-multi-select";

import { Text } from 'components/common/form/modules/input/Text';
import { addOrInviteUsers } from 'components/graphql/queries';
import * as JSCookie from 'js-cookie';
import { RolesSystem } from 'lib/enums/RolesSystem.enum';

import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import Switch from 'react-switch'
import FormText from "reactstrap/lib/FormText";
import { fetchGraphQL } from 'services/graphql/GraphQL';
import Error from '../../../../../../../components/alerts/Error';

enum TicketInventoryDomain {
    PUBLIC = "public",
    PRIVATE = "private"
}

export default class CreateTicketModal extends React.Component<
    {
        ticketType: TicketInventoryDomain;
        privateAdd: boolean;
        eventId: string;
        currency: string;
        remainingCapacity: number;
        onChange: (e: any) => void;
        onClose: () => void;
        onCreate: (e: any) => void;
        setPromoter?: (e: string) => void;
        selectPromoter?: (e: any) => void,
        generalLinkShow?: boolean;
        onChangeGeneralLinkAvailable?: () => void,
        changeAllocateIndividually?: () => void,
        users?: any;
        promoterId?: string;
        promoters?: any[];
        currentPromoter?: string;
        referral?: boolean;
    },
    {
        [label: string]: any;
    }
    > {
    constructor(props) {
        super(props);
        this.state = {
            reachCap: false,
            newVal: '',
            options: [],
            selected: [],
            ticketNames: [],
            quantity: 0,
            price: 0,
            otherName: '',
            otherNameUsed: false,
            priceError: false,
            noPromoterError: props.referral ? true : false,
            overAllocation: false,
            remainingCapacity: props.remainingCapacity,
            infiniteQuantity: false,
            checked: props.generalLinkShow,
            allocateIndividually: false,
            paymentSetup: false
        }
        this.changeProm = this.changeProm.bind(this);
        this.multiSelectCallBack = this.multiSelectCallBack.bind(this);
        this.verifyIfPaidTicketCanBeMade = this.verifyIfPaidTicketCanBeMade.bind(this);
        this.changeTicketName = this.changeTicketName.bind(this)
        this.selectTicketName = this.selectTicketName.bind(this)
        this.changeInfiniteTicketOption = this.changeInfiniteTicketOption.bind(this);
        this.handleReferralCodeChange = this.handleReferralCodeChange.bind(this);
        this.handleReferralCodeSubmit = this.handleReferralCodeSubmit.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this)
        this.changeAllocateIndividually = this.changeAllocateIndividually.bind(this);
    }

    public handleCheckBoxChange() {
        if (this.props.onChangeGeneralLinkAvailable) {
            this.props.onChangeGeneralLinkAvailable()
            this.setState({
                checked: !this.state.checked
            })
        }
    }

    public componentDidMount() {
        const options: any[] = []
        this.props.users!.map((item: any) => {
            options.push({
                label: item.name + ' ' + item.lastname + (item.email.includes('@isotope-referral-code.com') ? ' (referral link)' : ' (' + item.email + ')'),
                value: item.id
            })
        })
        const selected: string[] = []
        this.setState({
            selected, options
        })
        // get ticket names here
        fetchGraphQL(`
        query {
            ticketBank {
                get(eventId:"${this.props.eventId}") {
                    name
                }
            }
        }
        `).then(r => {

            fetchGraphQL(`
            query {
                event {
                    hasEventCreatorSetupPayments(eventId:"${this.props.eventId}")
                }
            }
        `).then(res => {
                // Extra checks in place after a bug that was discovered with changing prices.
                // This is the only place that could have possibly taken place,
                // as maybe the response turned out to be weird
                if (res !== undefined && res !== null) {
                    if (res.event !== undefined && res.event !== null) {
                        if (res.event.hasEventCreatorSetupPayments !== undefined && res.event.hasEventCreatorSetupPayments !== null) {
                            if (res.event.hasEventCreatorSetupPayments === true) {
                                this.setState({ paymentSetup: true })
                            }
                        }
                    }
                }
                const unique = r.ticketBank.get.filter((v, i, a) => a.findIndex(t => (t.name === v.name)) === i)
                this.setState({
                    ticketNames: unique
                })
            })
        })
    }

    public changeAllocateIndividually() {
        // if (this.state.quantity * this.state.selected.length > this.state.remainingCapacity && this.state.allocateIndividually) {
        //     this.setState({
        //         overAllocation: true
        //     })
        //     return;
        // }
        if (this.props.changeAllocateIndividually) {
            this.props.changeAllocateIndividually();
            this.setState({
                allocateIndividually: !this.state.allocateIndividually
            })
        }
    }

    public handleReferralCodeSubmit(e) {
        e.preventDefault()
        if (this.props.referral && this.state.otherNameUsed) {
            // First create user
            const email = this.state.otherName.split(' ').join().toLowerCase() + '@isotope-referral-code.com';
            fetchGraphQL(addOrInviteUsers(), JSCookie.get("token"), {
                emails: email.trim(),
                roleId: RolesSystem.PROMOTER,
                eventId: this.props.eventId
            }).then(result => {
                fetchGraphQL(`
                query {
                    user {
                        findByEmail(email:"${email.trim()}") {
                            id
                        }
                    }
                }
                `).then(res => {
                    if (this.props.setPromoter) {
                        this.props.setPromoter(res.user.findByEmail.id);
                        this.props.onCreate(e);
                        this.props.onClose();
                        window.location.reload();
                    }
                })
            });
        } else {
            this.props.onCreate(e);
            this.props.onClose();
        }
    }

    public handleReferralCodeChange(e) {
        if (e.target.value === undefined || e.target.value === null || e.target.value === '') {
            this.setState({
                otherName: '',
                otherNameUsed: false
            })
        } else if (e.target.value.includes('@')) {
            return
        } else {
            this.setState({
                otherName: e.target.value,
                otherNameUsed: true
            })
        }
    }

    public changeInfiniteTicketOption() {
        if (this.state.infiniteQuantity) {
            this.setState({
                infiniteQuantity: false,
                quantity: 0
            })
            this.props.onChange({
                target: {
                    name: 'quantity',
                    value: 0
                }
            });
        } else {
            this.setState({
                infiniteQuantity: true,
                quantity: -1
            })
            this.props.onChange({
                target: {
                    name: 'quantity',
                    value: -1
                }
            });
        }
    }

    public verifyIfPaidTicketCanBeMade(e: any) {

        // no real need to do this, its bad practice. But trying to go through a random 
        const x = e.target.value;
        const z = e.target.value;

        if (e.target.value === null || e.target.value === 0 || String(e.target.value) === '0' || Number(e.target.value) === 0) {
            this.setState({
                priceError: false,
                price: 0
            })
            this.props.onChange({ target: { name: "price", value: 0 } })
            return;
        }

        if (this.state.paymentSetup === true) {
            this.setState({
                priceError: false,
                price: Number(z)
            })
            this.props.onChange({
                target: {
                    name: "price",
                    value: Number(x)
                }
            })
        } else {
            this.setState({
                priceError: true
            })
        }

    }

    public multiSelectCallBack(selected: any) {
        // this.setState({
        //     otherNameUsed: false
        // })
        // // If you try and allocate more promoters such that num(p) * quantity > capacity
        // // Then you have over allocated and your selection will not go through
        // const itemsSelected = this.state.checked ? selected.length + 1 : selected.length
        // if (this.state.quantity * itemsSelected > this.state.remainingCapacity && this.state.allocateIndividually) {
        //     this.setState({
        //         overAllocation: true
        //     })
        //     return;
        // }
        this.setState({ selected })
        if (this.props.selectPromoter !== undefined) {
            this.props.selectPromoter(selected)
        }
    }

    public changeProm(promId: any) {
        this.setState({ newVal: promId });
    }

    public changeTicketName(e) {
        this.props.onChange({
            target: {
                name: 'name',
                value: e
            }
        })
    }

    public selectTicketName(e) {
        if (e[0] !== undefined) {
            this.props.onChange({
                target: {
                    name: 'name',
                    value: e[0].name
                }
            })
        }
    }

    public render() {

        const itemsSelected = this.state.checked ? this.state.selected.length + 1 : this.state.selected.length
        const overselected = ((itemsSelected * this.state.quantity) > this.state.remainingCapacity) && this.state.allocateIndividually
        const nothingSelected = this.state.selected.length === 0 && !this.state.checked

        if (this.props.ticketType === TicketInventoryDomain.PUBLIC) {
            return (
                <div>
                    <form>
                        <label>→ Name</label>
                        <Typeahead
                            id="name"
                            labelKey="name"
                            name="name"
                            options={this.state.ticketNames}
                            onInputChange={e => this.changeTicketName(e)}
                            onChange={e => this.selectTicketName(e)}
                            style={{ backgroundColor: '#ebecf1' }}
                        />
                        <br />
                        <label>→ Quantity</label>
                        <input
                            type="number"
                            min={0}
                            max={this.state.remainingCapacity}
                            name="quantity"
                            disabled={this.state.infiniteQuantity}
                            onChange={(e: any) => {
                                if (Number(e.target.value) > this.state.remainingCapacity) {
                                    this.setState({
                                        reachCap: true,
                                        quantity: Number(e.target.value)
                                    });
                                } else {
                                    this.setState({
                                        reachCap: false,
                                        quantity: Number(e.target.value)
                                    });
                                }
                                this.props.onChange(e);
                            }
                            }
                            className="form-control mb-4"
                            required={true}
                        />
                        <p>
                            OR
                        </p>
                        <div>
                            <div style={{ textAlign: 'left', width: '100%' }}>
                                <div>
                                    <div style={{ height: '30px', lineHeight: '40px' }}>
                                        <Switch
                                            checked={this.state.infiniteQuantity}
                                            onChange={this.changeInfiniteTicketOption}
                                            onColor="#4d5adf"
                                            onHandleColor="#ffffff"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={true}
                                            boxShadow="0 2px 1px -1px gray"
                                            height={25}
                                            width={50}
                                            className="react-switch"
                                            id="material-switch"
                                        />
                                    </div>
                                    <div style={{ height: '20px', lineHeight: '20px', fontSize: '12px' }}>Unlimited</div>
                                </div>
                                <FormText color="muted">Sell until event capacity is reached.</FormText>
                            </div>
                            <p />
                        </div>
                        {this.state.reachCap || overselected ? <div><Error content={"Ticket quantity must be less than or equal to the remaining event capacity (" + this.state.remainingCapacity + ")"} /></div> : null}
                        <label><br />→ Price</label>
                        <div style={{ width: '100%', height: '60px' }}>
                            <div style={{ float: 'left', width: '8%', paddingTop: '3px' }}>
                                <h3>
                                    {
                                        this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                </h3>
                            </div>
                            <div style={{ float: 'right', width: '92%' }}>
                                <input
                                    type="number"
                                    min="0"
                                    name="price"
                                    onChange={this.verifyIfPaidTicketCanBeMade}
                                    className="form-control mb-4"
                                    required={true}
                                    value={this.state.price}
                                />
                            </div>
                        </div>
                        {this.state.priceError ? <Error content={'Event owner must set up payments before creating paid tickets.'} /> : null}
                        <br />
                        <div style={{ width: '100%', flexDirection: 'row' }}>
                            <div style={{ width: 'auto', float: 'left', paddingTop: '3px' }}>
                                → Sell through General Link
                            </div>
                            <div style={{ paddingLeft: '20px', float: 'left' }}>
                                <input type="checkbox" value="general-link" checked={
                                    this.state.checked
                                }
                                    onChange={e => {
                                        this.handleCheckBoxChange()
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                        <label>→ Sell through Promoters<br /></label>
                        <MultiSelect
                            options={this.state.options}
                            selected={this.state.selected}
                            onSelectedChanged={selected => this.multiSelectCallBack(selected)}
                        />
                        <br />
                        {
                            nothingSelected ?
                                <Error content="Allocate ticket to General Link/Promoters" />
                                : null
                        }
                        {/* {
                            overselected ?
                                <Error content={"Total tickets allocated exceeds remaining capacity (" + this.state.remainingCapacity.toString() + ")"} />
                                : null
                        } */}
                        <div style={{ width: '100%', flexDirection: 'row' }}>
                            <div style={{ width: 'auto', float: 'left', paddingTop: '3px' }}>
                                → Allocate Tickets Separately
                            </div>
                            <div style={{ paddingLeft: '20px', float: 'left' }}>
                                <input type="checkbox" value="general-link" checked={
                                    this.state.allocateIndividually
                                }
                                    onChange={e => {
                                        this.changeAllocateIndividually()
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                        <Text
                            label="→ Ticket Description"
                            name="description"
                            onChange={this.props.onChange}
                        />
                        <br />
                        <br />
                        <div className="Seperate-Buttons">

                            <button
                                className='new-button-white-3'
                                style={{
                                    border: 'none'
                                }}
                                onClick={this.props.onClose}
                            >
                                CANCEL
                            </button>

                            <button
                                className='new-button-white-3'
                                style={{
                                    border: 'none'
                                }}
                                onClick={e => {
                                    this.props.onCreate(e);
                                    this.props.onClose();
                                }}
                                disabled={this.state.priceError || nothingSelected || overselected}
                            >
                                CREATE
                            </button>
                        </div>
                    </form>
                </div>
            );
        }

        // else {
        //     if (this.props.privateAdd) {
        //         return (
        //             <div>
        //                 <form>
        //                     <label>Ticket Name</label>
        //                     <Typeahead
        //                         id="name"
        //                         labelKey="name"
        //                         name="name"
        //                         options={this.state.ticketNames}
        //                         onInputChange={e => this.changeTicketName(e)}
        //                         onChange={e => this.selectTicketName(e)}
        //                         style={{ backgroundColor: '#ebecf1' }}
        //                     /><br />
        //                     <label>Quantity</label>
        //                     <input
        //                         type="number"
        //                         min={0}
        //                         max={this.state.remainingCapacity}
        //                         disabled={this.state.infiniteQuantity}
        //                         name="quantity"
        //                         onChange={(e: any) => {
        //                             if (Number(e.target.value) > this.state.remainingCapacity) {
        //                                 this.setState({
        //                                     reachCap: true
        //                                 });
        //                             }
        //                             else {
        //                                 this.setState({
        //                                     reachCap: false
        //                                 });
        //                             }
        //                             this.props.onChange(e);
        //                         }
        //                         }
        //                         className="form-control mb-4"
        //                         required={true}
        //                     />
        //                     <p>
        //                         OR
        //                 </p>
        //                     <div>
        //                         <div style={{ textAlign: 'left', width: '100%' }}>
        //                             <div>
        //                                 <div style={{ height: '30px', lineHeight: '40px' }}>
        //                                     <Switch
        //                                         checked={this.state.infiniteQuantity}
        //                                         onChange={this.changeInfiniteTicketOption}
        //                                         onColor="#4d5adf"
        //                                         onHandleColor="#ffffff"
        //                                         handleDiameter={25}
        //                                         uncheckedIcon={false}
        //                                         checkedIcon={true}
        //                                         boxShadow="0 2px 1px -1px gray"
        //                                         height={25}
        //                                         width={50}
        //                                         className="react-switch"
        //                                         id="material-switch"
        //                                     />
        //                                 </div>
        //                                 <div style={{ height: '20px', lineHeight: '20px', fontSize: '12px' }}>Unlimited</div>
        //                             </div>
        //                             <FormText color="muted">Can sell till event capacity is reached.</FormText>
        //                         </div>
        //                         <p />
        //                     </div>
        //                     {this.state.reachCap ? <div><Error content={"Ticket quantity must be less than or equal to the remaining event capacity (" + this.state.remainingCapacity + ")"} /></div> : null}
        //                     <label>Price</label>
        //                     <div style={{ width: '100%', height: '60px' }}>
        //                         <div style={{ float: 'left', width: '8%', paddingTop: '3px' }}>
        //                             <h3>
        //                                 {
        //                                     this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
        //                                 }
        //                             </h3>
        //                         </div>
        //                         <div style={{ float: 'right', width: '92%' }}>
        //                             <input
        //                                 type="number"
        //                                 min={0}
        //                                 name="price"
        //                                 onChange={this.verifyIfPaidTicketCanBeMade}
        //                                 className="form-control mb-4"
        //                                 required={true}
        //                             />
        //                         </div>
        //                     </div>
        //                     {this.state.priceError ? <Error content={'Event owner must set up payments before creating paid tickets.'} /> : null}
        //                     <br />
        //                     <label>Choose Promoters<br /></label>
        //                     <MultiSelect
        //                         options={this.state.options}
        //                         selected={this.state.selected}
        //                         onSelectedChanged={selected => this.multiSelectCallBack(selected)}
        //                     />
        //                     {this.state.overAllocation ? <div><Error content={"Cannot choose more promoters to allocate " + this.state.quantity + " tickets to. Only " + this.state.remainingCapacity + " more tickets can be allocated based on your event capacity."} /></div> : null}
        //                     <br />
        //                     <Text
        //                         label="Description"
        //                         name="description"
        //                         onChange={this.props.onChange}
        //                     />
        //                     <br />
        //                     <div className="Seperate-Buttons">

        //                         <button
        //                             className='new-button-white-3'
        //                             style={{
        //                                 border: 'none'
        //                             }}
        //                             onClick={this.props.onClose}
        //                         >
        //                             CANCEL
        //                         </button>

        //                         <button
        //                             role="submit"
        //                             type="submit"
        //                             className='new-button-white-3'
        //                             style={{
        //                                 border: 'none'
        //                             }}
        //                             onClick={e => {
        //                                 this.props.onCreate(e);
        //                                 this.props.onClose();
        //                             }}
        //                             disabled={this.state.priceError}
        //                         >
        //                             CREATE
        //                         </button>
        //                     </div>
        //                 </form>
        //             </div>
        //         );
        //     }
        //     else {
        //         return (
        //             <div>
        //                 <form>
        //                     <label>Ticket Name</label>
        //                     <Typeahead
        //                         id="name"
        //                         labelKey="name"
        //                         name="name"
        //                         options={this.state.ticketNames}
        //                         onInputChange={e => this.changeTicketName(e)}
        //                         onChange={e => this.selectTicketName(e)}
        //                         style={{ backgroundColor: '#ebecf1' }}
        //                     /><br />
        //                     <label>Quantity</label>
        //                     <input
        //                         type="number"
        //                         name="quantity"
        //                         min={0}
        //                         disabled={this.state.infiniteQuantity}
        //                         max={this.state.remainingCapacity}
        //                         onChange={(e: any) => {
        //                             if (Number(e.target.value) * this.state.selected.length > this.state.remainingCapacity) {
        //                                 this.setState({
        //                                     reachCap: true
        //                                 });
        //                             } else {
        //                                 this.setState({
        //                                     reachCap: false,
        //                                     overAllocation: false,
        //                                     quantity: Number(e.target.value)
        //                                 });
        //                             }
        //                             this.props.onChange(e);
        //                         }
        //                         }
        //                         className="form-control mb-4"
        //                         required={true}
        //                     />
        //                     <p>
        //                         OR
        //                     </p>
        //                     <div>
        //                         <div style={{ textAlign: 'left', width: '100%' }}>
        //                             <div>
        //                                 <div style={{ height: '30px', lineHeight: '40px' }}>
        //                                     <Switch
        //                                         checked={this.state.infiniteQuantity}
        //                                         onChange={this.changeInfiniteTicketOption}
        //                                         onColor="#4d5adf"
        //                                         onHandleColor="#ffffff"
        //                                         handleDiameter={25}
        //                                         uncheckedIcon={false}
        //                                         checkedIcon={true}
        //                                         boxShadow="0 2px 1px -1px gray"
        //                                         height={25}
        //                                         width={50}
        //                                         className="react-switch"
        //                                         id="material-switch"
        //                                     />
        //                                 </div>
        //                                 <div style={{ height: '20px', lineHeight: '20px', fontSize: '12px' }}>Unlimited</div>
        //                             </div>
        //                             <FormText color="muted">Can sell till event capacity is reached.</FormText>
        //                         </div>
        //                         <p />
        //                     </div>
        //                     {this.state.reachCap ? <div><Error content={"Ticket quantity must be less than or equal to the remaining event capacity (" + this.state.remainingCapacity + ")"} /></div> : null}
        //                     <label>Price</label>
        //                     <div style={{ width: '100%', height: '60px' }}>
        //                         <div style={{ float: 'left', width: '8%', paddingTop: '3px' }}>
        //                             <h3>
        //                                 {
        //                                     this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
        //                                 }
        //                             </h3>
        //                         </div>
        //                         <div style={{ float: 'right', width: '92%' }}>
        //                             <input
        //                                 type="number"
        //                                 min={0}
        //                                 name="price"
        //                                 onChange={this.verifyIfPaidTicketCanBeMade}
        //                                 className="form-control mb-4"
        //                                 required={true}
        //                             />
        //                         </div>
        //                     </div>
        //                     {this.state.priceError ? <Error content={'Event owner must set up payments before creating paid tickets.'} /> : null}
        //                     {this.state.noPromoterError && (!this.state.otherNameUsed) ? <div><Error content={"Choose at least one promoter to give tickets to or enter a code to assign referral link to."} /></div> : null}
        //                     <label>Choose Promoters<br /></label>
        //                     <MultiSelect
        //                         options={this.state.options}
        //                         selected={this.state.selected}
        //                         onSelectedChanged={selected => this.multiSelectCallBack(selected)}
        //                     />
        //                     {this.state.overAllocation ? <div><Error content={"Cannot choose more promoters to allocate " + this.state.quantity + " tickets to. Only " + this.state.remainingCapacity + " more tickets can be allocated based on your event capacity."} /></div> : null}
        //                     {
        //                         this.props.referral ?
        //                             <div>
        //                                 <p>
        //                                     <br />OR
        //                                 </p>
        //                                 <Text
        //                                     label="Referral Code"
        //                                     value={this.state.otherName}
        //                                     name="Code"
        //                                     onChange={this.handleReferralCodeChange}
        //                                 />
        //                             </div> : null
        //                     }
        //                     <br />
        //                     <Text
        //                         label="Description"
        //                         name="description"
        //                         onChange={this.props.onChange}
        //                     />
        //                     <br />
        //                     <div className="Seperate-Buttons">
        //                         <button
        //                             className='new-button-white-3'
        //                             style={{
        //                                 border: 'none'
        //                             }}
        //                             onClick={this.props.onClose}
        //                         >
        //                             CANCEL
        //                         </button>
        //                         <button
        //                             className='new-button-white-3'
        //                             style={{
        //                                 border: 'none'
        //                             }}
        //                             type="button"
        //                             onClick={this.handleReferralCodeSubmit}
        //                             disabled={this.state.priceError || (this.state.noPromoterError && !this.state.otherNameUsed)}
        //                         >
        //                             CREATE
        //                         </button>
        //                     </div>
        //                 </form>
        //             </div >
        //         );
        //     }
        // }
    }
}


// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ticketInventory/modules/CreateTicketModal.tsx